import styled from 'styled-components'

export default styled.div`
  .stats-hero .ant-statistic-title {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textMuted};
    margin-bottom: 4px;
  }

  .stats-hero .ant-statistic-content {
    line-height: 1.2;
  }

  .stats-hero .stat-title {
    white-space: nowrap;
  }

  .actions-bar {
    margin-top: 12px;
    padding: 8px 12px;
    background: ${(props) => props.theme.tokens.surfaceHover};
    border-radius: 6px;
  }

  .customer-compact {
    font-size: 13px;
    line-height: 1.5;
  }

  .customer-compact .customer-header {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px dashed ${(props) => props.theme.tokens.borderSubtle};
  }

  .customer-compact .customer-name {
    font-size: 15px;
  }

  .customer-compact .customer-id-link,
  .customer-compact .new-order-link {
    margin-left: auto;
  }

  .customer-compact .new-order-link {
    margin-left: 0;
  }

  .customer-compact .customer-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px 16px;
  }

  .customer-compact .customer-field {
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${(props) => props.theme.tokens.textSecondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .customer-compact .field-icon {
    color: ${(props) => props.theme.tokens.textMuted};
    flex-shrink: 0;
  }

  .customer-compact .customer-note {
    margin-top: 8px;
    padding: 6px 8px;
    background: ${(props) => props.theme.tokens.highlightWarning};
    border-left: 2px solid #ffd666;
    border-radius: 2px;
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textSecondary};
  }

  @media (max-width: 575px) {
    .actions-bar {
      padding: 8px;
    }

    .customer-compact .customer-grid {
      grid-template-columns: 1fr;
    }

    .customer-compact .customer-id-link {
      margin-left: 0;
    }
  }
`
